import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar tool menu to JPS templating.
*/
@Component({
	selector: 'jps-menu',
	templateUrl: './jps-menu.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class JpsMenuComponent extends BaseComponent {

	/**
	* Display JPS template menu tools.
	*/
	enableTemplate(): void {
		if (this.isEocCut) {
			this.goToTemplate();
		}
	}

	private goToTemplate(): void {
		this.canvasSrv.dispatch('switchToTemplating');
		this.canvasSrv.saveState();
	}

	/**
	* Start template selection workflow.
	*/
	openTemplateSelection(): void {
		this.canvasSrv.dispatch('startInsertingPlate');
	}

}
